module.exports = __webpack_public_path__ + "static/media/Frame-piece-collection.221465c6.png";